/**
 * ConfirmPopin — dialogue de confirmation standard.
 * Construit sur <Popin> + <Button> du design system pour garantir
 * un footer et des boutons toujours alignés et cohérents.
 */

import React from 'react';
import { Popin, PopinFooter, type PopinSize } from './Popin';
import { Button, type ButtonVariant } from '../Button';

export interface ConfirmPopinProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Variante du bouton de confirmation (primary par défaut, danger pour les suppressions) */
  confirmVariant?: ButtonVariant;
  confirmDisabled?: boolean;
  loading?: boolean;
  size?: PopinSize;
}

export const ConfirmPopin: React.FC<ConfirmPopinProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  confirmDisabled = false,
  loading = false,
  size = 'sm',
}) => {
  return (
    <Popin
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={
        <PopinFooter>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={confirmDisabled}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </PopinFooter>
      }
    >
      {children}
    </Popin>
  );
};

export default ConfirmPopin;
